import classnames from 'classnames';
import { AvailableItems } from 'models/forms/fields/AvailableItemsField';
import { CSSProperties, FC } from 'react';

import { RawCompactList } from './RawCompactList';

interface NewListProps {
  id: string;
  className?: string;
  availableItems: AvailableItems;
  value: Nullable<string>;
  onValueChanged: (value: string) => void;
  isInvalid?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  selectStyle?: CSSProperties;
}
export const CompactList: FC<NewListProps> = ({ className, selectStyle, ...props }) => {
  return (
    <div className={classnames('form-group mb-0 me-1', className)}>
      <RawCompactList style={selectStyle} {...props} />
    </div>
  );
};

CompactList.displayName = 'CompactList';
